import './wall-paper.css';

// The paper is only a display layer. Opening it always uses the original image.
export default function CertificatePaper({ src, label = 'Certificate', onOpen, index = 0, children }) {
  return <article className="tl-paper-milestone" style={{
    '--paper-duration': `${9 + index % 4 * 1.1}s`,
    '--paper-phase': `${-index * 2.7 - 1.8}s`,
    '--paper-tilt': index % 2 ? '2.5deg' : '-2.5deg',
    '--paper-turn': index % 2 ? '-1.8deg' : '1.8deg',
    '--paper-drift': index % 2 ? '-9px' : '9px',
  }}>
    {/* The stationary button owns hover and clicks; the paper keeps drifting
        inside it, so animated edges cannot repeatedly enter and leave. */}
    <button type="button" className="tl-paper-stage" data-swipe-start data-swipe-thumbnail aria-label={`View ${label} certificate`} onClick={onOpen}>
      <span className="tl-paper-ground-shadow" aria-hidden="true"/>
      <span className="tl-paper-lift">
        <span className="tl-paper-tilt"><span className="tl-paper-surface">
          <span className="tl-paper-certificate">
            <img src={src} alt={label} loading="lazy" decoding="async"/>
            <span className="tl-paper-glaze" aria-hidden="true"/>
            <span className="tl-paper-inspect">View original ↗</span>
          </span>
        </span></span>
      </span>
    </button>
    {children && <div className="tl-paper-details">{children}</div>}
  </article>;
}
